import {IPage} from '@brix/shared-frontend';
import {Box, Container, Typography} from '@mui/material';
import {CreatePropertyForm} from './CreatePropertyForm';

const CreatePropertyView: React.FunctionComponent<IPage> = () => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 3,
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="xl">
        <CreatePropertyForm />
      </Container>
    </Box>
  );
};

export default CreatePropertyView;
